var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComplianceIcon(_vm.asset),{tag:"component",style:({fill: _vm.getComplianceColor(_vm.asset)})})
}
var staticRenderFns = []

export { render, staticRenderFns }